import { AutoLogout, EmulationBanner, Footer, MenuBar } from "@/App/components";
import { ExperienceContext } from "@/App/context";
import React, { ComponentType, ReactNode, useContext, useEffect, useState } from "react";

const EmptyWrapper: React.FC<{ children: ReactNode }> = ({ children }) => (
  <>{children}</>
);

interface Props {
  children: ReactNode;
  pageTitle: string;
  label: string;
  showIconLogo: boolean;
  wrapperComponent?: ComponentType<{ children: ReactNode }>;
}

export const MainLayout: React.FC<Props> = ({
  children,
  pageTitle,
  wrapperComponent: Wrapper = EmptyWrapper,
}) => {
  const { experience } = useContext(ExperienceContext);
  const [isEmulation, setIsEmulation] = useState("");

  const documentPageTitle = () => {
    if (experience) {
      return pageTitle;
    } else {
      return `${site.companyName} - ${pageTitle}`;
    }
  };

  useEffect(() => {
    const body = document.body;
    body.classList.remove("authnz-root");
    document.title = documentPageTitle();

    setIsEmulation(sessionStorage.getItem("isEmulation"));
  }, []);

  return (
    <>
      <AutoLogout />
      <MenuBar />
      {isEmulation && <EmulationBanner />}

      <Wrapper>
        {children}
        <Footer isPadded={Wrapper === EmptyWrapper}/>
      </Wrapper>
    </>
  );
};
